import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from 'components/DropdownMenu'

import { GoToPlatform } from './GoToPlatform'
import { Logout } from './Logout'
import { RedirectToLogin } from './RedirectToLogin'
import { UserMenuInitials } from './UserMenuInitials'

export const NoAccessUserMenu = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <UserMenuInitials username="-" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-72 lg:w-56 xl:w-64 2xl:w-72">
        <RedirectToLogin />
        <GoToPlatform />
        <Logout />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
